var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCounter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75 65.987C81.0662 69.0344 86.2672 73.9248 90.0635 80.0401C90.8153 81.2511 91.1912 81.8566 91.3211 82.6951C91.5852 84.399 90.42 86.4939 88.8331 87.1682C88.0521 87.5 87.1736 87.5 85.4167 87.5M66.6667 48.051C72.8405 44.9829 77.0833 38.6119 77.0833 31.25C77.0833 23.8881 72.8405 17.5171 66.6667 14.449M58.3333 31.25C58.3333 41.6053 49.9387 50 39.5833 50C29.228 50 20.8333 41.6053 20.8333 31.25C20.8333 20.8947 29.228 12.5 39.5833 12.5C49.9387 12.5 58.3333 20.8947 58.3333 31.25ZM10.6635 78.9098C17.3064 68.9356 27.789 62.5 39.5833 62.5C51.3776 62.5 61.8603 68.9356 68.5032 78.9098C69.9585 81.0948 70.6861 82.1873 70.6024 83.583C70.5371 84.6697 69.8248 86 68.9565 86.6566C67.8413 87.5 66.3076 87.5 63.2402 87.5H15.9265C12.859 87.5 11.3253 87.5 10.2102 86.6566C9.34186 86 8.62953 84.6697 8.5643 83.583C8.48053 82.1873 9.20817 81.0948 10.6635 78.9098Z",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter2);
export default __webpack_public_path__ + "static/media/counter2.54a0c215444fc146b2f295eb3c4f3938.svg";
export { ForwardRef as ReactComponent };